import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useRecruiterPermission } from '../../hooks/useRecruiterPermission';


interface PermissionProtectedRouteProps {
  children: React.ReactNode;
  permission: string;
}

export function PermissionProtectedRoute({ children, permission }: PermissionProtectedRouteProps) {
  const { profile, isLoadingInitial } = useAuth();
  const { hasPermission, isLoading: isLoadingPermission } = useRecruiterPermission(permission);

  if (isLoadingInitial || isLoadingPermission) {
    return (
      <div className="flex items-center justify-center min-h-screen">
      
      </div>
    );
  }

  if (profile?.company_role !== 'recruiter' && profile?.company_role !== 'admin') {
    return <>{children}</>;
  }

  if (profile?.company_role === 'recruiter' && !hasPermission) {
    return <Navigate to="/404" replace />;
  }

  return <>{children}</>;
}